import { first, get, isArray } from 'lodash'
import React from 'react'
import { Form } from 'react-bootstrap'
import { CSSProperties } from 'styled-components'

import { isValidReactNode } from '../../../utils'
import Label from '../Label'
import { TField } from '../types'

type TFieldComponent = Pick<
  TField,
  | 'style'
  | 'inline'
  | 'inlineBlock'
  | 'children'
  | 'noMargin'
  | 'label'
  | 'tooltip'
  | 'hideLabel'
  | 'required'
  | 'isRequired'
  | 'hideFeedback'
  | 'feedback'
  | 'feedbackType'
>

const FieldComponent = (props: TFieldComponent): React.ReactElement => {
  const {
    style,
    inline,
    inlineBlock,
    children,
    noMargin,
    label,
    tooltip,
    hideLabel,
    required,
    isRequired,
    hideFeedback,
    feedback,
    feedbackType,
  } = props

  const formGroupStyle = {
    ...style,
  }

  if (inline) {
    formGroupStyle.display = 'inline'
  }

  if (inlineBlock) {
    formGroupStyle.display = 'inline-block'
  }

  const styleType = {
    styletype: feedbackType,
  }

  return (
    <Form.Group
      className={noMargin ? 'mb-0' : 'mb-1'}
      style={formGroupStyle as CSSProperties}
    >
      {label && (
        <Label
          tooltip={tooltip}
          hideLabel={hideLabel}
          label={label}
          required={required || isRequired}
        />
      )}
      {isValidReactNode(children) && children}

      {!hideFeedback && (
        <Form.Control.Feedback
          style={{ display: 'inline' }}
          className={`${feedbackType}-feedback`}
          {...styleType}
        >
          {!feedback && null}
          {feedback &&
            !feedback.props &&
            String(
              get(
                isArray(feedback) ? first(feedback) : feedback,
                'error',
                feedback,
              ),
            )}
          {feedback && feedback.props && feedback.props.children}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  )
}

export default FieldComponent
